module.exports = __webpack_public_path__ + "img/drawings_100x100.450c7921.png";